module.exports = __webpack_public_path__ + "static/media/k2.fb875499.jpg";